import Button from './button';

const WhySection = () => {
    const scrollToElement = (elementId) => {
        const element = document.getElementById(elementId);
        if (element) {
            const navbarHeight = 72;
            const y = element.getBoundingClientRect().top + window.scrollY - navbarHeight;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };

    return (
        <section className="why-section section-spacing" aria-label="Why trauma informed therapy matters">
            <div className="card-section-inner">
                <div className="card-body">
                    <div className="why-content">
                        <div className="why-content-right">
                            <img className="why-image" src={`${process.env.PUBLIC_URL}/assets/frustrated_llustration.png`} alt="Woman feeling stuck and searching for change in her life" loading="lazy" />
                        </div>
                        <div className="why-content-left">
                            <h2 className="text-brand-800">
                                "Life feels like it's passing by, and I'm not achieving what I want"
                            </h2>
                            <p className="text-textBody">
                                Do you feel like time is slipping by, leaving you wondering if you're truly living the life you want? Many people feel this way, working hard but unsure if they're on the right path. Together, we can clarify your goals, uncover what truly matters, and create a plan to bring you closer to a fulfilling life.
                            </p>
                            <p className="text-textBody">
                                Don't let another day go by without taking a step toward the change you deserve. If you are a new age mom or an entrepreneur or an ambitious woman juggling your priorities, wanting to heal yourself — I SEE YOU. Come, let's work together. Let yourself blossom. Every accomplishment starts with the decision to try.
                            </p>
                            <Button onClick={() => scrollToElement('booking-form')} type="primary" className="mt-2">
                                Schedule a Clarity Call Now
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhySection;
